import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Tooltip,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React from "react";
import Chart from "react-apexcharts";
import InformationCircleIcon from "../../../icons/InformationCircle";
import { BoxedLoader } from "../../BoxedLoader";

const PredictedTrends = ({ categories, data, title, tooltipInfo }) => {
  const theme = useTheme();

  const chart: any = data
    ? {
        series: [
          {
            name: "Min",
            type: "column",
            data: data.min,
            color: "#f4b73f",
          },
          {
            name: "Max",
            type: "column",
            data: data.max,
            color: "#1e4354",
          },
          {
            name: "Avg",
            type: "line",
            data: data.avg,
            color: "#5fc1f2",
          },
        ],
        options: {
          chart: {
            background: "transparent",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#f4b73f", "#1e4354", "#5fc1f2"],
          grid: {
            borderColor: theme.palette.divider,
            strokeDashArray: 2,
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
            labels: {
              colors: theme.palette.text.secondary,
            },
            show: true,
          },
          plotOptions: {
            bar: {
              columnWidth: "40%",
            },
          },
          stroke: {
            colors: ["transparent"],
            show: true,
            width: 2,
          },
          theme: {
            mode: theme.palette.mode,
          },
          tooltip: {
            theme: theme.palette.mode,
          },
          xaxis: {
            axisBorder: {
              show: true,
              color: theme.palette.divider,
            },
            axisTicks: {
              show: true,
              color: theme.palette.divider,
            },
            categories: categories,
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
          yaxis: {
            axisBorder: {
              color: theme.palette.divider,
              show: true,
            },
            axisTicks: {
              color: theme.palette.divider,
              show: true,
            },
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
        },
      }
    : {};
  return (
    <Card>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CardHeader title={title} />
        <Tooltip title={tooltipInfo}>
          <InformationCircleIcon fontSize="small" />
        </Tooltip>
      </Box>
      <Divider />
      <CardContent>
        {!data && <BoxedLoader height={"390px"} />}
        {data && <Chart height={390} {...chart} />}
      </CardContent>
    </Card>
  );
};

export default PredictedTrends;
